import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    price: 'body-3 mt-1'
  },
  image: {
    alignFill: 'center',
    height: 152,
    unSharpMask: 100,
    width: 123
  }
} satisfies RecursivePartial<ProductConfig['upsell']>
